import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
  object,
} from 'prop-types';
import React, { useEffect } from 'react';
import WithButtonState from '../../features/Button/WithButtonState';
import { Field } from '../../features/Form';
import AlertBoxForm from '../AlertBoxForm';
import { SubmitButton } from '../Buttons';
import InputField from '../InputField';
import { FormBoxWrapper, FormWrapper } from './styles';

function FormBox({
  status,
  buttonState,
  children,
  fields,
  form,
  handleClick,
  isFormDirty,
  isFormValid,
  setButtonState,
  isLoadingButton,
  renderSaveButton,
  currentApplicant,
}) {
  useEffect(() => {
    if (isLoadingButton) return;
    if (isFormValid && isFormDirty) setButtonState('attention');
    else if (!isFormValid || !isFormDirty) setButtonState('disabled');
  });
  return (
    <FormBoxWrapper>
      {status && status.type === 'REJECTED' && (
        <AlertBoxForm approvalStatus={status} />
      )}
      <FormWrapper>
        {form.map(
          ({
            description,
            id,
            placeholder,
            title,
            type,
            validation,
            component: C,
            key,
            option,
            ...rest
          }) => {
            let value;
            if (!fields) return <div />;
            else if (option && option.length === 1) {
              value = option[0].address;
            } else {
              value = fields && key ? fields[key][id.slice(0, -1)] : fields[id];
            }
            return (
              <Field
                name={id}
                component={C || InputField}
                key={id}
                placeholder={placeholder}
                description={description}
                title={title}
                type={type || 'text'}
                id={id}
                validation={validation}
                initialValue={value}
                option={option}
                currentApplicant={currentApplicant}
                {...rest}
              />
            );
          }
        )}

        {children}

        {renderSaveButton && (
          <SubmitButton
            buttonState={buttonState}
            title="Spara och fortsätt"
            clicked={handleClick}
          />
        )}
      </FormWrapper>
    </FormBoxWrapper>
  );
}

FormBox.propTypes = {
  status: shape({
    type: string,
  }),
  buttonState: string.isRequired,
  fields: shape({
    value: oneOfType([string, bool, number]),
    error: string,
    valid: bool,
  }),
  form: arrayOf(
    shape({
      description: string,
      id: string,
      placeholder: string,
      title: string,
      type: string,
      validation: string,
    })
  ).isRequired,
  handleClick: func.isRequired,
  isFormDirty: bool.isRequired,
  isFormValid: bool.isRequired,
  isLoadingButton: bool.isRequired,
  setButtonState: func.isRequired,
  renderSaveButton: bool,
  currentApplicant: object.isRequired, //eslint-disable-line
};

FormBox.defaultProps = {
  fields: null,
  status: {
    type: '',
  },
  renderSaveButton: true,
};

export default WithButtonState(FormBox);



// WEBPACK FOOTER //
// ./src/components/Form/FormBox.js